import React from 'react';
import { ShieldCheckIcon, CloudIcon, CpuChipIcon, DevicePhoneMobileIcon, ChartBarIcon, LockClosedIcon } from '@heroicons/react/24/outline';
export function WhatWeCover() {
  const topics = [{
    icon: ShieldCheckIcon,
    title: 'Cybersecurity & Online Protection',
    description: 'Comprehensive guides on staying safe online, protecting your digital identity, and defending against cyber threats'
  }, {
    icon: LockClosedIcon,
    title: 'Data Security, Privacy, and Protection',
    description: 'Expert insights on safeguarding your personal and business data in an increasingly connected world'
  }, {
    icon: CloudIcon,
    title: 'Network and Cloud Security',
    description: 'Understanding modern security challenges in cloud computing and network infrastructure'
  }, {
    icon: ShieldCheckIcon,
    title: 'VPNs and Digital Privacy Tools',
    description: 'Detailed reviews and comparisons of VPN services and privacy-enhancing technologies'
  }, {
    icon: CpuChipIcon,
    title: 'Artificial Intelligence (AI) & Emerging Technologies',
    description: 'Breaking down AI developments and emerging tech trends in accessible, practical terms'
  }, {
    icon: CloudIcon,
    title: 'Cloud Computing & SaaS Solutions',
    description: 'Evaluating cloud platforms and software-as-a-service tools for businesses and individuals'
  }, {
    icon: ChartBarIcon,
    title: 'Productivity and Business Software',
    description: 'Reviews of tools that help you work smarter, collaborate better, and achieve more'
  }, {
    icon: ShieldCheckIcon,
    title: 'Antivirus and Security Software',
    description: 'In-depth testing and comparison of security solutions to keep your devices protected'
  }, {
    icon: DevicePhoneMobileIcon,
    title: 'Web and Mobile App Development',
    description: 'Insights into development tools, frameworks, and best practices for creating digital products'
  }, {
    icon: ChartBarIcon,
    title: 'Software Reviews, Comparisons & Recommendations',
    description: 'Honest, unbiased reviews to help you choose the right software for your specific needs'
  }];
  return <section className="w-full py-20 px-6 bg-gray-50" data-id="element-99">
      <div className="max-w-6xl mx-auto" data-id="element-100">
        <h2 className="text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-101">
          What You'll Find Here
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-12 text-center max-w-3xl mx-auto" data-id="element-102">
          We cover a wide range of topics designed to keep you informed,
          protected, and productive in the digital age. Every article we publish
          is carefully researched, tested, and reviewed to ensure accuracy,
          reliability, and practical value for our readers.
        </p>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-103">
          {topics.map((topic, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-104">
              <topic.icon className="w-10 h-10 text-blue-600 mb-4" data-id="element-105" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-106">
                {topic.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-107">
                {topic.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}